module.exports = __webpack_public_path__ + "img/fbdd0d3.svg";